<template>
    <b-modal
        id="confirm-modal"
        no-close-on-backdrop
        no-close-on-esc
        hide-header
        hide-footer
        centered
        v-model="modalShow"
        @hidden="resetModal"
    >
        <div class="d-flex flex-column align-items-center justify-center-center my-2">
            <feather-icon
                id="view-modal"
                :icon="iconModal"
                :class="'text-'+type+ ' mb-2'"
                size="80"
            />
            <div class="text-center">
                <h3>{{titleModal}}</h3>
                <span v-if="pessoaRemover < 1">{{ infoTextPrefix }}<strong>{{ descricaoDose }}</strong>{{ infoTextSuffix }}</span> 
                <span v-else><span class="pb-1 text-danger">{{pessoaRemover}} pessoas selecionadas.</span> O registro de vacinação da vacina <strong>{{descricaoDose}}</strong> será excluído permanentemente, essa ação não poderá ser desfeita.</span>
            </div>
            
            <div class="d-flex mt-2">
              <div id="tooltip-container">
                <b-button :disabled="loading || disableCancel" v-if="cancel" variant="primary-button" class="mr-2" @click="cancelAction">
                  {{cancel}}
                </b-button>
              </div>
              <b-tooltip v-if="tooltipBtnCancel !== ''" target="tooltip-container" triggers="hover focus" placement="top">
                {{ tooltipBtnCancel }}
              </b-tooltip>

              <b-button id="button-confirm" :disabled="loading" :variant="'outline-'+type" @click="confirmAction" >
                <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                {{ action }}
              </b-button>
            </div>

            <transition name="fade">
                <div
                    v-if="showVacinaSelect"
                    class="mt-3 col-12 d-flex flex-column align-items-center"
                >
                    <label class="font_size_label">
                        Selecione a vacina
                    </label>
                    <v-select
                        v-model="selectedVacina"
                        :options="vacinasCampanha"
                        label="nome_tecnico_vacina"
                        placeholder="Escolha uma vacina"
                        class="vacina-select col-12"
                        @input="handleVacinaSelecionada"
                    >
                        <template #no-options>Nenhuma vacina disponível.</template>
                    </v-select>
                </div>
            </transition>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BButton, BTooltip } from 'bootstrap-vue';
import vSelect from 'vue-select'
export default {
    components: {
        BModal, BButton, BTooltip, vSelect
    },

    props: {
        modalShow: {
            required: true,
            type: Boolean
        },
        caseModal: {
            required: true,
            type: String
        },
        infoText: {
            type: String
        },
        pessoaRemover: {
            type: Number,
            required: false,
        },
        descricaoDose: {
            type: String,
            required: false,
        },
        disableCancel: {
            type: Boolean,
            default: false
        },
        tooltipBtnCancel: {
            type: String,
            default: ''
        },
        vacinasCampanha: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            loading: false,
            textComplement: '',
            modalTypes: [
                {
                    'type': 'danger',
                    'case': 'remover',
                    'action': 'Sim, remover',
                    'icon': 'AlertCircleIcon',
                    'cancel': 'Cancelar',
                    'title': 'Deseja remover vacinação?',
                    'infoText': 'O registro de vacinação da vacina {descricaoDose} será excluído permanentemente, essa ação não poderá ser desfeita.'
                },
                {
                    'type': 'danger',
                    'case': 'removerMultiplo',
                    'action': 'Sim, remover',
                    'icon': 'AlertCircleIcon',
                    'cancel': 'Cancelar',
                    'title': `Deseja remover vacinação?`,
                    'infoText': ''
                },
                {
                    'type': 'danger',
                    'case': 'selecionar',
                    'action': 'Entendido',
                    'icon': 'XCircleIcon',
                    'title': 'Selecione apenas 1 status',
                    'infoText': 'Não é possível marcar dois status ao mesmo tempo. Desmarque o status previamente selecionado e refaça sua seleção.'
                },
                {
                    'type': 'warning',
                    'case': 'desmarcar',
                    'cancel': 'Cancelar',
                    'action': 'Sim, desmarcar',
                    'icon': 'XCircleIcon',
                    'title': `Tem certeza que deseja desmarcar as pessoas?`,
                    'infoText': ''
                },
                {
                    'type': 'custom-blue',
                    'case': 'marcar',
                    'cancel': 'Não vacinados',
                    'action': 'Vacinados',
                    'icon': '',
                    'title': 'Selecione o status que deseja marcar nesta página:',
                    'infoText': ''
                },
                {
                    'type': 'warning',
                    'case': 'dosesDiferentes',
                    'action': 'Entendido',
                    'icon': 'AlertCircleIcon',
                    'cancel': false,
                    'title': 'Vacinação e cancelamento em massa só são permitidas para colaboradores na mesma dose. Ajuste a seleção.',
                    'infoText': ''
                }
            ],
            type: '',
            case: '',
            action: '',
            infoTextModal: '',
            titleModal: '',
            iconModal: '',
            cancel: false,
            count: 0,
            showVacinaSelect: false,
            selectedVacina: null
        }
    },

    computed: {
        infoTextPrefix() {
            const text = this.infoTextModal || '';
            const placeholder = '{descricaoDose}';
            const index = text.indexOf(placeholder);
            if (index === -1) {
                return text;
            }
            return text.substring(0, index);
        },
        infoTextSuffix() {
            const text = this.infoTextModal || '';
            const placeholder = '{descricaoDose}';
            const index = text.indexOf(placeholder);
            if (index === -1) {
                return '';
            }
            return text.substring(index + placeholder.length);
        }
    },

    methods: {
        confirmAction(modalEvent) {
            modalEvent.preventDefault();

            if(this.caseModal === 'marcar' && this.vacinasCampanha.length > 1 && !this.selectedVacina){
                this.showVacinaSelect = true;
                this.loading = false;
                return;
            }

            this.loading = true;

            if(this.caseModal == 'remover' || this.caseModal == 'removerMultiplo'){
                this.$emit('remove')
            }

            this.$emit('confirmed', modalEvent);
        },
        cancelAction(modalEvent) {
            modalEvent.preventDefault();

            this.$emit('canceled', modalEvent);
        },
        handleVacinaSelecionada(vacina) {
            this.selectedVacina = vacina;
            if (vacina) {
                this.$emit('vacina-selecionada', vacina);
            }
        },
        resetModal() {
            this.selectedVacina = null;
            this.showVacinaSelect = false;
            this.loading = false;
        },
    },

    watch: {
        modalShow() {
            this.loading = false;

            this.modalTypes.map(item => {
                if(item.case == this.$props.caseModal) {
                    this.action = item.action;
                    this.case = item.case;
                    this.type = item.type;
                    this.titleModal = item.title;
                    this.iconModal = item.icon;
                    this.cancel = item.cancel;

                    this.infoTextModal = (this.$props.infoText || item.infoText || '')
                        .replace('{pessoaRemover}', this.pessoaRemover || '');
                }
            });
        }
    }
}
</script>
